import type { CatalogueConfig } from '../catalogue/catalogue.types';
import type { Weapon } from './models/weapon.model';
import { WeaponStoreService } from './services/weapon-store.service';

export const WEAPON_CATALOGUE: CatalogueConfig<Weapon> = {
  label: 'Weapon',
  plural: 'Weapons',
  routeBase: '/weapons',
  storeToken: WeaponStoreService,
  placeholderIcon: '@tui.target',
  badges: (w) => [w.calibre ?? ''],
};
